import * as d3 from 'd3';
import { prepareStochastic } from '../prepIndicator/prepareStochastic';

export const drawStochasticOscillator = (svg, data, xScale, yScale, values, theme) => {
    try {
        // Trust the yScale the caller already built for this pane (its
        // domain is set from the real [0,100] default, see
        // D3SubCharts.js's getDefaultDomain) instead of recomputing one
        // here from args that were never actually passed by any caller.
        const stochasticYScale = yScale;

        // Prepare Stochastic Oscillator data
        const stochasticData = prepareStochastic(data, values);
        //console.log("Prepared Stochastic data:", stochasticData);

        if (!stochasticData || !stochasticData.stochastic_k || !stochasticData.stochastic_d) {
            console.warn("Incomplete or empty Stochastic Oscillator data:", stochasticData);
            return;
        }

        const validKData = stochasticData.stochastic_k.filter(point =>
            point.y !== null &&
            !isNaN(point.y) &&
            point.y >= stochasticYScale.domain()[0] &&
            point.y <= stochasticYScale.domain()[1]
        );

        const validDData = stochasticData.stochastic_d.filter(point =>
            point.y !== null &&
            !isNaN(point.y) &&
            point.y >= stochasticYScale.domain()[0] &&
            point.y <= stochasticYScale.domain()[1]
        );

        if (validKData.length === 0 || validDData.length === 0) {
            console.warn("No valid Stochastic Oscillator data points to plot", {
                stochastic_k: stochasticData.stochastic_k,
                stochastic_d: stochasticData.stochastic_d,
                validKData,
                validDData,
                yScaleDomain: stochasticYScale.domain(),
            });
            return;
        }

        // K Line (Stochastic %K)
        const kLine = d3.line()
            .x(d => xScale(d.x))
            .y(d => stochasticYScale(d.y))
            .curve(d3.curveMonotoneX);

        // D Line (Stochastic %D - Signal Line)
        const dLine = d3.line()
            .x(d => xScale(d.x))
            .y(d => stochasticYScale(d.y))
            .curve(d3.curveMonotoneX);

        const kColor = theme?.stochastic?.k || '#60a5fa';
        const dColor = theme?.stochastic?.d || '#f59e0b';

        // Render K Line
        svg.append("path")
            .datum(validKData)
            .attr("fill", "none")
            .attr("stroke", kColor)
            .attr("stroke-width", 1.5)
            .attr("d", kLine);

        // Render D Line
        svg.append("path")
            .datum(validDData)
            .attr("fill", "none")
            .attr("stroke", dColor)
            .attr("stroke-width", 1.5)
            .attr("d", dLine);

        // Reference lines (20/80) are drawn once by the caller
        // (D3SubCharts.js's addReferenceLines) -- not duplicated here.
    } catch (error) {
        console.warn("Error rendering Stochastic Oscillator:", error);
    }
};
